<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid form-group">
    <div class="col-12 md:col-3 lg:col-3">
      <div class="div-form">
        <label>* {{ 'PRODUCTO.LBL_PAIS' | translate }}</label>
        <p-dropdown disableTab  id="idAgrupacion" name="nomIdAgrupacion"
                    [options]="lisPaises"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                    (onChange)="cambiarPais($event.value)"
                    [(ngModel)]="idPaisSeleccionado"
                    [filter]="true"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-3 lg:col-3">
      <div class="div-form">
        <label>* {{ 'PRODUCTO.LBL_DEPARTAMENTO' | translate }}</label>
        <p-dropdown disableTab  id="idAgrupacion" name="nomIdAgrupacion"
                    [options]="lisDepartamentos"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                    (onChange)="cambiarDepartamento($event.value)"
                    [(ngModel)]="idDepartamentoSeleccionado"
                    [filter]="true"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-12 md:col-3 lg:col-3">
      <div class="div-form">
        <label>* {{ 'PRODUCTO.LBL_MUNICIPIO' | translate }}</label>
        <p-dropdown disableTab  id="idAgrupacion" name="nomIdAgrupacion"
                    [options]="lisMunicipios"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                    (onChange)="cambiarMunicipio($event.value)"
                    [(ngModel)]="idMunicipioSeleccionado"
                    [filter]="true"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-3 lg:col-3" style="display: flex; align-items: end;">
      <div class="div-form">
        <button type="button" pButton class="p-button-secondary" icon="fa fa-eraser"
                label="{{ 'AGENDA.BTN_LIMPIAR' | translate}}" (click)="limpiarFiltro()" [disabled]="ejecutandoRestriccion || guardando || carTabla"></button>

        <button type="submit" pButton class="p-button-success" icon="fa fa-filter"
                label="{{ 'AGENDA.BTN_FILTRAR' | translate}}" (click)="filtrarDepartamentoMunicipio()" [disabled]="ejecutandoRestriccion || guardando || carTabla"></button>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-5 lg:col-5">
      <div class="card card-w-title">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12 text-center text-color-primary" style="font-weight: bold; font-size: 16px">
            <label>{{ 'PRODUCTO.LBL_UBICACIONESNOHABILITADAS' | translate}}</label>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <div class="input-search-icon">
              <input
                size="40"
                type="text"
                pInputText
                placeholder="{{ 'LBL_BUSCAR' | translate }}"
                (input)="dt.filterGlobal($event.target.value, 'contains')"/>
              <i class="pi pi-search"></i>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <p-table
              #dt
              [rows]="10"
              [paginator]="true"

              [columns]="columnas"
              dataKey="idDivisionPolitica"
              paginatorPosition="bottom"
              [(selection)]="productoRestriccionBarrio"
              [value]="listaProductoRestriccionBarrio"
              [loading]="carTabla"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th style="width: 92px">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    {{ 'LBL_TODOS' | translate}}
                  </th>
                  <th
                    class="text-center"
                    *ngFor="let col of columns"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort"
                  >
                    {{ col.header }}
                    <p-sortIcon
                      *ngIf="col.sort"
                      [field]="col.field"
                    ></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>
                    <p-tableCheckbox [value]="row"></p-tableCheckbox>
                  </td>
                  <td>{{ row.camino }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length + 1" class="text-center">
                    {{ "MSG_NOHAYREGISTROS" | translate }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2 text-center" style="margin-top: 100px;">
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-right" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton (click)="restringir(productoRestriccionBarrio, true)" *ngIf="!ejecutandoRestriccion && !guardando && !carTabla"></button>
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-right" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton *ngIf="ejecutandoRestriccion || guardando || carTabla" [disabled]="true"></button>
      <br><br>
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-left" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton (click)="restringir(productoRestriccionBarrioRestringido, false)" *ngIf="!ejecutandoRestriccion && !guardando && !carTabla"></button>
      <button type="button" class="p-button btn" icon="fa fa-chevron-circle-left" data-toggle="tooltip"
              title="{{'BTN_TRASLADAR' | translate}}"
              pButton *ngIf="ejecutandoRestriccion || guardando || carTabla" [disabled]="true"></button>
      <br><br>
    </div>
    <div class="col-12 md:col-5 lg:col-5">
      <div class="card card-w-title">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12 text-center text-color-primary" style="font-weight: bold; font-size: 16px">
            <label>{{ 'PRODUCTO.LBL_UBICACIONESHABILITADAS' | translate}}</label>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <div class="input-search-icon">
              <input
                size="40"
                type="text"
                pInputText
                placeholder="{{ 'LBL_BUSCAR' | translate }}"
                (input)="dt2.filterGlobal($event.target.value, 'contains')"/>
              <i class="pi pi-search"></i>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <p-table
              #dt2
              [rows]="10"
              [paginator]="true"

              [columns]="columnas"
              dataKey="idDivisionPolitica"
              paginatorPosition="bottom"
              [(selection)]="productoRestriccionBarrioRestringido"
              [value]="listaFiltrada"
              [loading]="carTabla"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th style="width: 92px">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    {{ 'LBL_TODOS' | translate}}
                  </th>
                  <th
                    class="text-center"
                    *ngFor="let col of columns"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sort"
                  >
                    {{ col.header }}
                    <p-sortIcon
                      *ngIf="col.sort"
                      [field]="col.field"
                    ></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>
                    <p-tableCheckbox [value]="row"></p-tableCheckbox>
                  </td>
                  <td>{{ row.camino }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length + 1" class="text-center">
                    {{ "MSG_NOHAYREGISTROS" | translate }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a (click)="regresarFormulario(true) " class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                type="submit"
                (click)="onSubmit()"
                [disabled]="carTabla"
                pButton></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="producto-restriccion-barrios">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
